<template>
	<div class="col-md-12 col-sm-12 col-xs-12">
		<div class="trans-qr">
			<div class="row">
				<div>
					<div class="qr-img">
						<p class="img"><img :src="qrsrc" class="img-responsive"></p>
						<p v-if="showAcc">{{ txAccount.short_name }}: <a class="ac-copy" v-clipboard:copy="txAccount.bank_account" v-clipboard:success="onCopied">{{ txAccount.bank_account }}</a></p>
					</div>
					<div class="qr-action"> 
						<p>{{ tips }}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Button } from 'mint-ui'

export default {
	name: 'TransQr',
	data: () => ({
		'qrsrc': null,
		'tips': null,
		'accTitle': null,
		'it': null,
		'showAcc': false
	}),
	computed: {
		...mapGetters({
			txAccount: 'getTxAccount'
		})
	},
	components: {
		'mt-button': Button
	},
	created: function () {
	},
	mounted: function () {
		this.setPageTitle('订单支付')
		if (this.txAccount.weixin === true) {
			this.accTitle = '微信号'
			this.tips = '请代付⽅使⽤微信扫描此⼆维码完成转账，转账成功后需返回填写查账信息'
			this.qrsrc = '/static/img/qr-weixin.png'
			this.showAcc = false

			if (this.txAccount.short_code === "sd_weixin") {
				this.qrsrc = '/static/img/qr-weixin-sd.png'
			}
		} else if (this.txAccount.alipay === true) {
			this.accTitle = '支付宝账号'
			this.tips = '请代付⽅使⽤⽀付宝扫描此⼆维码或搜索公司账户完成转账, 转账成功后需返回填写查账信息'
			this.qrsrc = '/static/img/qr-alipay.png'
			this.showAcc = true

			if (this.txAccount.short_code === "sd_alipay") {
				this.qrsrc = '/static/img/qr-alipay-sd.png'
			}
		}
	},
	methods: {
		onCopied: function () {
			console.log(this.txAccount)
			this.toast('已复制' + this.accTitle)
		}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// TransQr.vue?c35a716c